var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useLanguage } from '@base/LanguageProvider';
import { UpdateCellWithTransformRequestValueTransformTypeEnum, WidgetType, } from '@common/api';
import WidgetParentChangeModal from '@main/dashboard/WidgetParentChangeModal';
import { useAuth } from '../../../providers/AuthProvider';
import useSimulationData from '@data/hooks/simulationData';
import { cellsApi } from '@data/rest/api';
import { useTagContext } from '@data/tag/tagContext';
import { parseWidgetConfig } from '@data/widgets/widgetConfig';
import { useCloneWidget, useDeleteWidget, useUpdateWidget } from '@data/widgets/widgetActions';
import WidgetLoader from '@main/dashboard/WidgetLoader';
import WidgetMenu from '@main/dashboard/WidgetMenu';
import { ContextMenu } from '@shared/contextmenu';
import { Copy, Delete, Edit, Plus, Select } from '@shared/icons/icons';
import { downArrow, upArrow } from '@shared/icons/tableIcons';
import Manager from '@shared/modal/Manager';
import { appColors } from '@styled/useTheme';
import { WidgetBox, WidgetContent } from '@styled/Widget';
import { NumberFormatType } from '@util/enums';
import { formatNumber } from '@util/formatNum';
import useTableCells from '@hooks/useTableCells';
import numbro from 'numbro';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import Sheet from 'sheet-happens';
import DataEditorColumnEditModal from './columnEditor';
import DataEditorEditor from './DataEditorEditor';
import SimulationRowEditModal from './simulationRowEditor';
function getBtns(text, cellWidth, upAction, downAction) {
    var content = {
        items: [],
    };
    content.items.push({
        x: 0,
        y: 0,
        content: text,
    });
    var iconHeight = 14;
    var iconWidth = iconHeight;
    var btnX = -cellWidth + iconWidth + 10;
    content.items.push({
        x: btnX,
        y: -iconHeight + 2,
        width: iconWidth,
        height: iconHeight,
        content: upArrow,
        onClick: upAction,
    });
    content.items.push({
        x: btnX,
        y: -2,
        width: iconWidth,
        height: iconHeight,
        content: downArrow,
        onClick: downAction,
    });
    return content;
}
function DataEditor(_a) {
    var _this = this;
    var gridId = _a.gridId, widget = _a.widget, documentActions = _a.documentActions, reloadGridData = _a.reloadGridData;
    var user = useAuth().user;
    var wrapperRef = useRef(null);
    var sheetWrapper = useRef(null);
    var L = useLanguage().L;
    var tagData = useTagContext().tagData;
    var updateWidget = useUpdateWidget();
    var cloneWidget = useCloneWidget();
    var deleteWidget = useDeleteWidget();
    var widgetConfig = useMemo(function () { return parseWidgetConfig(widget.config, WidgetType.SIMULATION); }, [widget.config]);
    var btnControlsActive = widgetConfig.dataEditorBtnControls && widgetConfig.dataEditorBtnControls.active
        ? widgetConfig.dataEditorBtnControls.active
        : false;
    var dataEditorCols = widgetConfig.dataEditorCols;
    var dataEditorRows = widgetConfig.dataEditorRows;
    var dataEditorValues = widgetConfig.dataEditorValues;
    var data = useSimulationData(dataEditorCols, dataEditorRows, dataEditorValues, widget.id);
    var _b = useTableCells(widgetConfig.dataEditorCellSizes.widths, widgetConfig.dataEditorCellSizes.heights), onCellWidthChange = _b.onCellWidthChange, onCellHeightChange = _b.onCellHeightChange, cellWidth = _b.cellWidth, cellHeight = _b.cellHeight;
    var _c = __read(useState({
        colIdx: -1,
        rowIdx: -1,
    }), 2), selectedColRow = _c[0], setSelectedColRow = _c[1];
    useEffect(function () {
        var _a, _b;
        if (JSON.stringify(cellWidth) !== JSON.stringify((_a = widgetConfig.dataEditorCellSizes) === null || _a === void 0 ? void 0 : _a.widths) ||
            JSON.stringify(cellHeight) !== JSON.stringify((_b = widgetConfig.dataEditorCellSizes) === null || _b === void 0 ? void 0 : _b.heights)) {
            var widgetCopy = __assign({}, widget);
            var widgetCopyConfig = __assign({}, widgetConfig);
            widgetCopyConfig.dataEditorCellSizes = { widths: cellWidth, heights: cellHeight };
            widgetCopy.config = JSON.stringify(widgetCopyConfig);
            updateWidget.mutate(widgetCopy);
        }
    }, [JSON.stringify(cellWidth), JSON.stringify(cellHeight)]);
    var addRowAction = function () {
        Manager.closeModal();
        Manager.renderModal(React.createElement(SimulationRowEditModal, { widget: widget }));
    };
    var editRowAction = function () {
        var row = dataEditorRows[selectedColRow.rowIdx];
        if (row) {
            Manager.closeModal();
            Manager.renderModal(React.createElement(SimulationRowEditModal, { widget: widget, row: row, rowIdx: selectedColRow.rowIdx }));
        }
    };
    var addColAction = function () {
        Manager.closeModal();
        Manager.renderModal(React.createElement(DataEditorColumnEditModal, { widget: widget }));
    };
    var editColAction = function () {
        var col = dataEditorCols[selectedColRow.colIdx];
        if (col) {
            Manager.closeModal();
            Manager.renderModal(React.createElement(DataEditorColumnEditModal, { widget: widget, column: col, columnIdx: selectedColRow.colIdx }));
        }
    };
    var readOnly = function (x, y) {
        var offsetedX = x - 1;
        var offsetedY = y - 1;
        if (x === 0 && y === 0) {
            return true;
        }
        else if (x === 0 && offsetedY < dataEditorRows.length) {
            return false;
        }
        else if (y === 0 && offsetedX < dataEditorCols.length) {
            return false;
        }
        else if (offsetedX < dataEditorCols.length && offsetedY < dataEditorRows.length) {
            return false;
        }
        else {
            return true;
        }
    };
    var editData = function (x, y) {
        var offsetedX = x - 1;
        var offsetedY = y - 1;
        if (x === 0 && y !== 0 && offsetedY < dataEditorRows.length) {
            var currRow = dataEditorRows[offsetedY];
            var label = currRow ? currRow.label : '';
            return label;
        }
        else if (y === 0 && x !== 0 && offsetedX < dataEditorCols.length) {
            var currCol = dataEditorCols[offsetedX];
            var label = currCol ? currCol.label : '';
            return label;
        }
        else if (offsetedX < dataEditorCols.length && offsetedY < dataEditorRows.length) {
            var value = data && data[offsetedY] && data[offsetedY][offsetedX] ? data[offsetedY][offsetedX].value : '';
            return typeof value === 'number' ? numbro(value).format() : '';
        }
        else {
            return '';
        }
    };
    var getRowLabel = function (item) {
        var label = '';
        if (item && item.label.trim() !== '') {
            label = item.label;
        }
        else if (item && item.tagIds) {
            var tagLabels_1 = [];
            item.tagIds.forEach(function (id) {
                var _a;
                if (tagData.tagById[id]) {
                    tagLabels_1.push(((_a = tagData.tagById[id]) === null || _a === void 0 ? void 0 : _a.name) || '');
                }
            });
            label = tagLabels_1.join(', ');
        }
        return label;
    };
    var changeSingleValue = function (currRow, currCol, newValue) { return __awaiter(_this, void 0, void 0, function () {
        var toChange, newDataEditorValues, widgetCopy, widgetCopyConfig, tagsIds, key, editType, value;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    toChange = [];
                    newDataEditorValues = dataEditorValues;
                    widgetCopy = __assign({}, widget);
                    widgetCopyConfig = parseWidgetConfig(widgetCopy.config, WidgetType.SIMULATION);
                    tagsIds = __spreadArray(__spreadArray([], __read(currRow.tagIds), false), __read(currCol.tagIds), false);
                    if (currRow.sourceVersionTagId) {
                        tagsIds.push(currRow.sourceVersionTagId);
                    }
                    tagsIds.sort(function (a, b) { return a - b; });
                    if (currRow && currCol) {
                        key = tagsIds.join(',');
                        if (newValue !== null) {
                            editType = currRow.editType;
                            value = newValue;
                            if (currRow.editType === 'PERCENT') {
                                editType = UpdateCellWithTransformRequestValueTransformTypeEnum.Mul;
                                value = 1 + newValue / 100;
                            }
                            toChange.push({
                                valueTransformType: editType,
                                value: value,
                                tagIdTransform: [[currRow.sourceVersionTagId, currRow.targetVersionTagId]],
                                sourceTagIds: tagsIds,
                            });
                            newDataEditorValues[key] = newValue;
                        }
                        else {
                            delete newDataEditorValues[key];
                        }
                    }
                    widgetCopyConfig.dataEditorValues = newDataEditorValues;
                    widgetCopy.config = JSON.stringify(widgetCopyConfig);
                    return [4 /*yield*/, updateWidget.mutateAsync(widgetCopy)];
                case 1:
                    _a.sent();
                    if (!(toChange.length > 0)) return [3 /*break*/, 3];
                    return [4 /*yield*/, cellsApi.updateBatchWithTransform(toChange)];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    reloadGridData === null || reloadGridData === void 0 ? void 0 : reloadGridData();
                    return [2 /*return*/];
            }
        });
    }); };
    var upArrowAction = function (currRow, currCol, rawValue) {
        var _a;
        var step = ((_a = widgetConfig.dataEditorBtnControls) === null || _a === void 0 ? void 0 : _a.step) || 0;
        var newValue = (rawValue !== null ? rawValue : 0) + step;
        changeSingleValue(currRow, currCol, newValue);
    };
    var downArrowAction = function (currRow, currCol, rawValue) {
        var _a;
        var step = ((_a = widgetConfig.dataEditorBtnControls) === null || _a === void 0 ? void 0 : _a.step) || 0;
        var newValue = (rawValue !== null ? rawValue : 0) - step;
        changeSingleValue(currRow, currCol, newValue);
    };
    var displayData = useCallback(function (x, y) {
        var offsetedX = x - 1;
        var offsetedY = y - 1;
        if (x === 0 && y === 0) {
            return '';
        }
        else if (x === 0 && y !== 0 && offsetedY < dataEditorRows.length) {
            var currRow = dataEditorRows[offsetedY];
            var label = getRowLabel(currRow);
            return label;
        }
        else if (y === 0 && x !== 0 && offsetedX < dataEditorCols.length) {
            var currCol = dataEditorCols[offsetedX];
            var label = getRowLabel(currCol);
            return label;
        }
        else if (offsetedX < dataEditorCols.length && offsetedY < dataEditorRows.length) {
            var currRow_1 = dataEditorRows[offsetedY];
            var currCol_1 = dataEditorCols[offsetedX];
            var rawValue_1 = data && data[offsetedY] && data[offsetedY][offsetedX] ? data[offsetedY][offsetedX].value : null;
            var value = formatNumber(rawValue_1, NumberFormatType.TWO_DECIMALS);
            if (currRow_1 && currRow_1.editType === 'PERCENT' && value !== '') {
                value = "".concat(value, "%");
            }
            return btnControlsActive
                ? getBtns(value, cellWidth[x], function () { return upArrowAction(currRow_1, currCol_1, rawValue_1); }, function () { return downArrowAction(currRow_1, currCol_1, rawValue_1); })
                : value;
        }
        else {
            return '';
        }
    }, [dataEditorRows, dataEditorCols, data, cellWidth]);
    var sourceData = function (x, y) {
        var offsetedX = x - 1;
        var offsetedY = y - 1;
        if (x === 0 && y !== 0 && offsetedY < dataEditorRows.length) {
            var currRow = dataEditorRows[offsetedY];
            var label = currRow ? currRow.label : '';
            return label;
        }
        else if (y === 0 && x !== 0 && offsetedX < dataEditorCols.length) {
            var currCol = dataEditorCols[offsetedX];
            var label = currCol ? currCol.label : '';
            return label;
        }
        else if (offsetedX < dataEditorCols.length && offsetedY < dataEditorRows.length) {
            var value = data && data[offsetedY] && data[offsetedY][offsetedX] ? data[offsetedY][offsetedX].value : '';
            return value;
        }
        else {
            return '';
        }
    };
    var onChange = function (changes) { return __awaiter(_this, void 0, void 0, function () {
        var toChange, newDataEditorValues, widgetCopy, widgetCopyConfig;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    toChange = [];
                    newDataEditorValues = dataEditorValues;
                    widgetCopy = __assign({}, widget);
                    widgetCopyConfig = parseWidgetConfig(widgetCopy.config, WidgetType.SIMULATION);
                    changes.forEach(function (change) {
                        var offsetedX = change.x - 1;
                        var offsetedY = change.y - 1;
                        if (change.x === 0 && offsetedY < dataEditorRows.length) {
                            if (widgetCopyConfig.dataEditorRows) {
                                widgetCopyConfig.dataEditorRows[offsetedY].label = change.value ? "".concat(change.value) : '';
                            }
                        }
                        else if (change.y === 0 && offsetedX < dataEditorCols.length) {
                            if (widgetCopyConfig.dataEditorCols) {
                                widgetCopyConfig.dataEditorCols[offsetedX].label = change.value ? "".concat(change.value) : '';
                            }
                        }
                        else if (offsetedX < dataEditorCols.length && offsetedY < dataEditorRows.length) {
                            var currRow = dataEditorRows[offsetedY];
                            var currCol = dataEditorCols[offsetedX];
                            var tagsIds = __spreadArray(__spreadArray([], __read(currRow.tagIds), false), __read(currCol.tagIds), false);
                            if (currRow.sourceVersionTagId) {
                                tagsIds.push(currRow.sourceVersionTagId);
                            }
                            tagsIds.sort(function (a, b) { return a - b; });
                            if (currRow && currCol) {
                                var newValue = numbro.unformat(change.value);
                                if (isNaN(newValue)) {
                                    if (typeof change.value === 'string') {
                                        try {
                                            var evald = eval(change.value);
                                            if (!isNaN(evald)) {
                                                newValue = evald;
                                            }
                                            else {
                                                newValue = null;
                                            }
                                        }
                                        catch (e) {
                                            newValue = null;
                                        }
                                    }
                                    else {
                                        newValue = null;
                                    }
                                }
                                var key = tagsIds.join(',');
                                if (newValue !== null) {
                                    var editType = currRow.editType;
                                    var value = newValue;
                                    if (currRow.editType === 'PERCENT') {
                                        editType = UpdateCellWithTransformRequestValueTransformTypeEnum.Mul;
                                        value = 1 + newValue / 100;
                                    }
                                    toChange.push({
                                        valueTransformType: editType,
                                        value: value,
                                        tagIdTransform: [[currRow.sourceVersionTagId, currRow.targetVersionTagId]],
                                        sourceTagIds: tagsIds,
                                    });
                                    newDataEditorValues[key] = newValue;
                                }
                                else {
                                    delete newDataEditorValues[key];
                                }
                            }
                        }
                    });
                    widgetCopyConfig.dataEditorValues = newDataEditorValues;
                    widgetCopy.config = JSON.stringify(widgetCopyConfig);
                    return [4 /*yield*/, updateWidget.mutateAsync(widgetCopy)];
                case 1:
                    _a.sent();
                    if (!(toChange.length > 0)) return [3 /*break*/, 3];
                    return [4 /*yield*/, cellsApi.updateBatchWithTransform(toChange)];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    reloadGridData === null || reloadGridData === void 0 ? void 0 : reloadGridData();
                    return [2 /*return*/];
            }
        });
    }); };
    var onSelectionChange = function (x1, y1, x2, y2) {
        var offsetedX = x1 - 1;
        var offsetedY = y1 - 1;
        setSelectedColRow({ colIdx: offsetedX, rowIdx: offsetedY });
    };
    var cellStyle = function (x, y) {
        var offsetedX = x - 1;
        var offsetedY = y - 1;
        var fontSize = widgetConfig.dataEditorFontSize || 15;
        if ((x === 0 && y !== 0 && offsetedY < dataEditorRows.length) ||
            (y === 0 && x !== 0 && offsetedX < dataEditorCols.length)) {
            return {
                fontSize: fontSize,
                color: appColors.ui.dark,
                fontFamily: 'Inter',
            };
        }
        else if (offsetedX < dataEditorCols.length && offsetedY < dataEditorRows.length) {
            return {
                textAlign: 'right',
                fontSize: fontSize,
                color: appColors.ui.dark,
                fontFamily: 'Inter',
            };
        }
        else {
            return { fontSize: 15, color: appColors.ui.dark, fontFamily: 'Inter' };
        }
    };
    var widgetMenuItems = [
        {
            icon: Edit,
            actionName: L('Edit Tile'),
            isDisabled: !(documentActions === null || documentActions === void 0 ? void 0 : documentActions.canUpdate),
            action: function () { return Manager.renderModal(React.createElement(DataEditorEditor, { gridId: gridId, widget: widget })); },
        },
        {
            icon: Copy,
            actionName: L('Duplicate'),
            isDisabled: !(user === null || user === void 0 ? void 0 : user.classActions.documentClassActions.canDuplicate),
            action: function () { return cloneWidget.mutate(widget); },
        },
        {
            icon: Select,
            actionName: L('Move to'),
            isDisabled: !(documentActions === null || documentActions === void 0 ? void 0 : documentActions.canUpdate),
            action: function () { return Manager.renderModal(React.createElement(WidgetParentChangeModal, { widget: widget, gridId: gridId })); },
        },
        { spacer: true },
        {
            icon: Delete,
            actionName: L('Delete Tile'),
            isDisabled: !(documentActions === null || documentActions === void 0 ? void 0 : documentActions.canDelete),
            action: function () { return deleteWidget.mutate(widget.id); },
            destructive: true,
        },
    ];
    var sheetMenuItems = [
        {
            icon: Plus,
            actionName: L('Add row'),
            action: addRowAction,
            creative: true,
        },
        {
            icon: Plus,
            actionName: L('Add column'),
            action: addColAction,
            creative: true,
        },
        { spacer: true },
        {
            icon: Edit,
            actionName: L('Edit row'),
            action: editRowAction,
            isDisabled: selectedColRow.rowIdx >= dataEditorRows.length || selectedColRow.rowIdx < 0,
        },
        {
            icon: Edit,
            actionName: L('Edit col'),
            action: editColAction,
            isDisabled: selectedColRow.colIdx >= dataEditorCols.length || selectedColRow.colIdx < 0,
        },
    ];
    return (React.createElement(React.Fragment, null,
        React.createElement(WidgetBox, { ref: wrapperRef },
            React.createElement(WidgetMenu, { menuItems: widgetMenuItems }),
            React.createElement(WidgetContent, { ref: sheetWrapper, onMouseDown: function (e) { return e.stopPropagation(); } },
                React.createElement(Sheet, { onSelectionChanged: onSelectionChange, cellStyle: cellStyle, columnHeaderStyle: { fontFamily: 'Inter', fontSize: 12 }, editData: editData, displayData: displayData, sourceData: sourceData, cellWidth: cellWidth, cellHeight: cellHeight, onChange: onChange, readOnly: readOnly, onCellWidthChange: onCellWidthChange, onCellHeightChange: onCellHeightChange, sheetStyle: {
                        freezeColumns: 1,
                    } }),
                React.createElement(ContextMenu, { items: sheetMenuItems, triggerRefs: [{ ref: sheetWrapper }] }))),
        React.createElement(WidgetLoader, { wId: widget.id })));
}
export default DataEditor;
